import { ComercioApi as Api } from "./comercio.api";
export class ComercioFacade {
  static countWithFilter(filter) {
    return Api.countWithFilter(filter);
  }

  static create(createDto) {
    return Api.create(createDto);
  }

  static delete(id) {
    return Api.delete(id);
  }

  static getById(id) {
    return Api.getById(id);
  }

  static getActiveList() {
    return Api.getActiveList();
  }

  static getListWithFilter(filter) {
    return Api.getListWithFilter(filter);
  }

  static getMinimumDiscountPercentageByComercioId(comercioId) {
    return Api.getMinimumDiscountPercentageByComercioId(comercioId);
  }

  static hasBeneficioWithLowerDiscount(comercioId, discountPercentage) {
    return Api.hasBeneficioWithLowerDiscount(comercioId, discountPercentage);
  }

  static update(updateDto) {
    return Api.update(updateDto);
  }

  static uploadLogo(comercioId, formData) {
    return Api.uploadLogo(comercioId, formData);
  }
}
